export default "__VITE_ASSET__Djk4OlPJ__"